import { render, staticRenderFns } from "./ReviewsFullListController.vue?vue&type=template&id=08bd6f18&scoped=true&"
import script from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
export * from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsFullListController.vue?vue&type=style&index=0&id=08bd6f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd6f18",
  null
  
)

export default component.exports